export const ON_LOADING = "loadingReducer/ON_LOADING";

export const setLoading = (val)  => (disptch) => {
  return disptch({
    type: ON_LOADING,
    payload: val,
  });
};